import { cn } from '@/lib/cn'

/// Кольцевой индикатор — замена CircularProgressIndicator.
///
/// Раньше кольцо рисовалось рамкой с прозрачной верхней гранью: дуга получалась
/// с рублеными краями и обрывалась на стыке. Здесь это дуга в SVG — с бледной
/// дорожкой под ней и скруглёнными концами.
export function Spinner({ size = 20, className }: { size?: number; className?: string }) {
  const stroke = Math.max(2, Math.round(size / 9))
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius

  return (
    <svg
      role="progressbar"
      aria-label="Загрузка"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={cn('inline-block shrink-0 animate-spin', className)}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={stroke}
        opacity={0.2}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${circumference * 0.3} ${circumference}`}
      />
    </svg>
  )
}
